import { useLayoutEffect } from 'react'

export default function useFixedBottomPadding(ref, elementPaddingBottom = 'app') {
  useLayoutEffect(() => {
    const app = document.getElementById(elementPaddingBottom)
    const fixedBottomElement = ref.current

    if (!fixedBottomElement || !app) return

    const updatePadding = () => {
      app.style.paddingBottom = `${fixedBottomElement.offsetHeight}px`
    }

    updatePadding()
    window.addEventListener('resize', updatePadding)

    let resizeObserver = null
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(updatePadding)
      resizeObserver.observe(fixedBottomElement)
    }

    return () => {
      app.style.paddingBottom = '0px'
      window.removeEventListener('resize', updatePadding)
      resizeObserver?.disconnect()
    }
  }, [elementPaddingBottom, ref])
}
